/* Vanilla JS for Request A Proposal form
   - Reads data- attributes from .request-proposal
   - Handles Recaptcha (if present), validation, submits to API
   - Shows validation errors and thank-you message
*/

document.addEventListener('DOMContentLoaded', function () {
        console.log('Starting');
    document.querySelectorAll('.request-proposal').forEach(function (block) {
        var dataset = block.dataset || {};
        var recaptchaKey = dataset.recaptchaKey || '';
        var emailTemplateId = dataset.emailTemplateId || '';
        var pageMadeOn = dataset.pageMadeOn || '';
        var formName = dataset.formName || '';

        var form = block.querySelector('.request-proposal-form');
        var complete = block.querySelector('.form-complete');
        var errorWrapper = block.querySelector('.validation-summary-errors');
        var errorList = errorWrapper ? errorWrapper.querySelector('ul') : null;
        var submitButtons = block.querySelectorAll('.cta-link');

        function getFieldValue(name) {
            var el = form.querySelector('[name="' + name + '"]');
            if (!el) return '';
            if (el.tagName === 'SELECT') return el.value;
            if (el.type === 'checkbox') return !!el.checked;
            return el.value || '';
        }

        function showErrors(errors) {
            if (!errorWrapper || !errorList) return;
            errorList.innerHTML = '';
            errors.forEach(function (err) {
                var li = document.createElement('li');
                li.textContent = err;
                errorList.appendChild(li);
            });
            errorWrapper.style.display = '';
            // scroll to error area
            var rect = errorWrapper.getBoundingClientRect();
            window.scrollTo({ top: window.scrollY + rect.top - 120, behavior: 'smooth' });
        }

        function hideErrors() {
            if (!errorWrapper) return;
            errorList.innerHTML = '';
            errorWrapper.style.display = 'none';
        }

        function submitRequest(recaptchaToken) {
            console.log('Submitting request proposal form with data:', {
                FirstName: getFieldValue('FirstName'),
                LastName: getFieldValue('LastName'),
                TelephoneNumber: getFieldValue('TelephoneNumber'),
                EmailAddress: getFieldValue('EmailAddress'),
                EventLocation: getFieldValue('EventLocation'),
                AdditionalDetails: getFieldValue('AdditionalDetails'),
                GDPRAcceptance: getFieldValue('GDPRAcceptance') === true || getFieldValue('GDPRAcceptance') === 'true',
                ReCaptchaResponse: recaptchaToken || '',
                PageMadeOn: pageMadeOn && pageMadeOn.length ? pageMadeOn : (window.location && window.location.pathname ? window.location.pathname : '/'),
                EmailTemplateID: Number(emailTemplateId) || 0
            });
            hideErrors();
            var payload = {
                FormType: 'RequestProposalForm',
                FirstName: getFieldValue('FirstName'),
                LastName: getFieldValue('LastName'),
                TelephoneNumber: getFieldValue('TelephoneNumber'),
                EmailAddress: getFieldValue('EmailAddress'),
                EventLocation: getFieldValue('EventLocation'),
                AdditionalDetails: getFieldValue('AdditionalDetails'),
                GDPRAcceptance: getFieldValue('GDPRAcceptance') === true || getFieldValue('GDPRAcceptance') === 'true',
                ReCaptchaResponse: recaptchaToken || '',
                PageMadeOn: pageMadeOn && pageMadeOn.length ? pageMadeOn : (window.location && window.location.pathname ? window.location.pathname : '/'),
                EmailTemplateID: Number(emailTemplateId) || 0
            };

            // disable buttons
            submitButtons.forEach(function (b) { b.disabled = true; b.classList.add('disabled'); });

            fetch('/Umbraco/Api/RequestProposalFormApi/SubmitRequestProposalForm', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json; charset=utf-8' },
                body: JSON.stringify(payload)
            }).then(function (res) { return res.json().then(function (d) { return { status: res.status, data: d }; }); })
              .then(function (resp) {
                var data = resp.data || {};
                if (resp.status === 200 && data.success === true) {
                    if (form) form.style.display = 'none';
                    if (complete) complete.style.display = '';

                    if (formName && formName.length > 0) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ event: 'formSubmission', formName: formName });
                    }

                    // scroll to form
                    if (form) {
                        var rect = form.getBoundingClientRect();
                        window.scrollTo({ top: window.scrollY + rect.top - 150, behavior: 'smooth' });
                    }
                } else {
                    var errors = [];
                    if (data && Array.isArray(data.errors)) errors = data.errors;
                    else if (data && data.error) errors.push(data.error);
                    else errors.push('An issue occurred when attempting to send your request.');
                    showErrors(errors);
                }
            }).catch(function () {
                showErrors(['An issue occurred when attempting to send your request.']);
            }).finally(function () {
                submitButtons.forEach(function (b) { b.disabled = false; b.classList.remove('disabled'); });
            });
        }

        function handleSubmitClick(e) {
            console.log('starting');
            e.preventDefault();
            if (recaptchaKey && typeof grecaptcha !== 'undefined' && grecaptcha.execute) {
                grecaptcha.execute(recaptchaKey, { action: 'homepage' }).then(function (token) {
                    submitRequest(token);
                });
            } else {
                submitRequest();
            }
        }

        submitButtons.forEach(function (btn) { btn.addEventListener('click', handleSubmitClick); });

    });
});


